import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../route/auth/auth.service';
import { AppUrls } from '../../route/app-urls';
import { AppConfig } from '../../appconfig';
import { SettingsService } from '../../shared/settings/settings.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ldw-auth-failed',
    templateUrl: './auth-failed.component.html',
    styleUrls: ['./auth-failed.component.css'],
    standalone: false
})
export class AuthFailedComponent implements OnInit {
  private authService = inject(AuthService);
  private config = inject(AppConfig);
  private settingsService = inject(SettingsService);
  private translate = inject(TranslateService);

  public longVersion = '';

  ngOnInit(): void {
    this.longVersion = 'Version ' + this.config.version();
  }

  login(e: any) {
    this.authService.login(AppUrls.baseUrlAngular);
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
